module.exports = __webpack_public_path__ + "static/media/zgj.d64ade82.png";